<template>
	<div>
		<div class="row">
			<div class="col-12">
				<InputText id="email" name="Email Address" type="email" :form="values" :errors="errors" v-on:enter-pressed="request"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12 forgotten">
				<router-link to="/login">Login</router-link>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<button class="button-action" @click="request">Get New Password</button>
			</div>
		</div>
	</div>
</template>

<script>
import auth from '../../lib/auth'
import InputText from '../Form/InputText.vue'
import InputSelect from '../Form/InputSelect.vue'

export default {
	components: {
		InputText
	},
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['email'],
		}
	},
	methods: {
		formIsValid() {
			const emailRegex = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})
			
			if(validForm) {
				if(emailRegex.test(this.values.email) == false) {
					this.errors.email = 'Email address is invalid.'
					validForm = false
				}
			}

			return validForm
		},
		request() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			this.$store.commit('app/setLoading', true)
			auth.resetPassword(this.values.email)
			.then(response => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: 'Check your email for the confirmation link'
				})
				this.$router.push({ path: '/login' })
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	}
}
</script>

<style lang="scss">
@import "./../../scss/variables.scss";
.reset-password {
	.password {
		padding-bottom: 5px;
	}
	.forgotten {
		padding-bottom: 20px;
		a {
			display: block;
			color: $brand-color
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/ResetPassword/Form.vue